<template>
  <div class="main-body">
    <div class="my-4">
      <h3 class="text-2xl mb-6">课程：{{ detail.name }}-<span class="text-xl">{{ file.alias }}</span></h3>
      <div class="bg-white shadow-lg w-full rounded-xl overflow-hidden">
        <VideoPlayer :id="file.id" :courseId="$route.query.cid" :url="file.m3u8"/>
      </div>
    </div>
    <div class="absolute right-0 top-0 h-full flex items-center">
      <el-button circle icon="el-icon-back" type="info" @click="showComment = true"></el-button>
    </div>
    <el-drawer
        title="评论列表"
        :visible.sync="showComment"
        direction="rtl">
      <span>我来啦!</span>
    </el-drawer>
  </div>

</template>
<script>
import VideoPlayer from "@/components/VideoPlayer";

export default {
  name: "login",
  /**
   * 调用组建
   * @type {Object}
   */
  components: {
    VideoPlayer
  },
  /**
   * 组建属性
   * @type {Object}
   */
  props: {},
  /**
   * 数据字段
   * @return {[type]} [description]
   */
  data() {
    return {
      detail: {},
      file: {},
      showComment: false
    };
  },
  /**
   * 计算属性
   * @type {Object}
   */
  computed: {},
  /**
   * 数据监听
   * @type {Object}
   */
  watch: {},
  /**
   * 页面创建时
   * @return {[type]} [description]
   */
  created() {

  },
  /**
   * 页面加载时
   * @return {[type]} [description]
   */
  mounted() {
    if (this.$route.query.cid) {
      this.handleLoadData()
      this.handleLoadVideo()
    }
  },
  /**
   * 页面调用函数
   * @type {Object}
   */
  methods: {
    handleLoadData() {
      $cloud.get("/course/detail", {id: this.$route.query.cid}).then(data => {
        this.detail = data
      })
    },
    handleLoadVideo() {
      $cloud.post("/files/detail", {id: this.$route.query.id}).then(data => {
        this.file = data
      })
    }
  }
};
</script>
<style scoped>

</style>
